import type { AxiosResponse } from 'axios';
import { ApiService } from '@/services/api';
import type { clientApiResponseType } from './types';
import type { CandidateRegistration } from '@/types/candidateRegistration';
import type { candidateRegistrationResponse } from '@/types/candidateRegistrationResponse';

type useCandidateType = {
  getCandidateState: () => Promise<AxiosResponse<clientApiResponseType>>;
  registerCandidate: (
    userId: string,
    params: CandidateRegistration,
  ) => Promise<AxiosResponse<candidateRegistrationResponse>>;
};

function useCandidate(): useCandidateType {
  const { api } = ApiService();

  function getCandidateState(): Promise<AxiosResponse<clientApiResponseType>> {
    return api.get<clientApiResponseType>('/fintech/v1/clients');
  }

  function registerCandidate(userId: string, params: CandidateRegistration) {
    return api.put<candidateRegistrationResponse>(
      `/fintech/v1/clients/${userId}`,
      params,
    );
  }

  return { getCandidateState, registerCandidate };
}

export default useCandidate;
